import React from 'react'
import { FormMorphology } from './FormMorphology';
import { Dialog } from 'primereact/dialog';

export const ModalMorphology = (props) => {

    const {
        modal, modalTitle, closeDialog, method,
        validaciones,
        morphology,
        handleInputChange, loading,
        saveCreate, saveUpdate, saveDelete
    } = props;

    return (
         <Dialog 
                header={modalTitle}
                visible={modal}
                onHide={closeDialog}
                closable={true}
                modal
                blockScroll
                className='tiny-dialog'
            >
       
            {
                method === "create"
                    ? <FormMorphology
                        button={"Crear morfologia"}
                        {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormMorphology
                            button={"Actualizar morfologia"}
                            {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, morphology, }} />
                        :
                        null
            }
        </Dialog>
    )
}
